import { defineStore } from 'pinia'

export const useDesignSystemStore = defineStore('designSystem', {
  state: () => ({
    verifiedFilter: 'all' as 'all' | 'verified' | 'not-verified',
    packageFilter: 'all' as 'all' | 'package' | 'not-package',
  }),
})
